import { Component, Input } from '@angular/core';
import { LanguagesService } from '../../../services/languages.service';
import {
  getStatusBonus,
  StatusBonus,
  STATUS_BONUS_EXAMPLE_PRICE_EUR,
} from '../../model/status-bonus.model';
import { ProfileService } from 'src/app/profile/services/profile.service';

@Component({
  selector: 'app-status-bonus-panel',
  templateUrl: './status-bonus-panel.component.html',
  styleUrls: ['./status-bonus-panel.component.scss'],
})
export class StatusBonusPanelComponent {
  @Input() premiumPartnerLevel: number;
  @Input() open: boolean = false;

  protected readonly examplePriceInEur = STATUS_BONUS_EXAMPLE_PRICE_EUR;

  constructor(
    public languageService: LanguagesService,
    private profileService: ProfileService,
  ) {}

  get bonus(): StatusBonus | null {
    return getStatusBonus(
      this.examplePriceInEur,
      this.premiumPartnerLevel,
      this.profileService.statusBonusPercent,
    );
  }
}
